<template>

  <div v-if="type != 'textarea'" :class="col">
    <div class="rueden-input">
      <label class="bold-600" v-if="label">
        {{ label }}
        <span v-if="required" class="required-input" :class="{'error-input' : $v.content.$error || $v.fakeContent.$error}">* </span>
        <a v-if="tooltip" v-tooltip="{content: tooltip, trigger: 'click' }">
          <i class="fa fa-question-circle-o"></i>
        </a>
      </label>

      <input v-if="(!showFakeControl || !hasFocus) && (type != 'tel' || (iOSv && iOSv < 13))"
          key="normalInput"
          :placeholder="placeholder"
          @change="updateValue"
          class="form-control"
          :pattern="pattern"
          :type="[showFakeControl || showDatePicker ? 'text' : htmlType]"
          v-model="content"
          :required="required"
          @focus="changeFocus(true)"
          @blur="changeFocus(false)"
          :min="[showFakeControl ? '' : htmlMin]"
          :max="[showFakeControl ? '' : htmlMax]"
          :class="[{'hide-placeholder' : type == 'date' && !content}, {'border-danger' : $v.content.$error || $v.fakeContent.$error}]"
          @keyup="cleanFormat"
      />

      <input
          v-if="showFakeControl"
          key="fakeInput"
          :placeholder="placeholder"
          @change="updateValue"
          class="form-control"
          :class="[{'fake-control' : !hasFocus}, {'border-danger' : $v.content.$error || $v.fakeContent.$error}]"
          :pattern="pattern"
          :type="htmlType"
          v-model="fakeContent"
          :required="required"
          :min="htmlMin"
          :max="htmlMax"
          :step="htmlStep"
          @focus="changeFocus(true)"
          @blur="changeFocus(false)"
          ref="mainInput"
      />
      <datepicker
          v-if="showDatePicker"
          key="dateInput"
          input-class="form-control fake-control"
          format="dd.MM.yyyy"
          v-model="fakeContent"
          :required="required"
          :monday-first="true"
          :language="lang"
          :full-month-name="true"
          @input="updateValue"
          ref="mainInput"
      />

      <div class="row" v-if="type=='tel' && $global.countries && (!iOSv || iOSv >= 13)">
        <div class="col-4 pr-0">
          <div class="control-select">
            <select style="padding-left: 10px; padding-right: 25px" name="country_select" id="country_select" class="" v-model="countrySelect" v-if="showCountrySel">
              <optgroup>
                <template v-for="option in $global.countries">
                  <option v-if="option.code == preSelectCountry || favCountries.includes(option.code)" v-bind:value="option.code" :key="option.code" :label="(option.flag ? option.flag + ' ' : '') + option.code">
                    {{ option.flag ? option.flag + ' ' : '' }}{{ option.code }}
                  </option>
                </template>
              </optgroup>
              <optgroup label="  -  ">
                <template v-for="option in $global.countries">
                  <option v-if="option.code != preSelectCountry && !favCountries.includes(option.code)" v-bind:value="option.code" :key="option.code" :label="(option.flag ? option.flag + ' ' : '') + option.code">
                    {{ option.flag ? option.flag + ' ' : '' }}{{ option.code }}
                  </option>
                </template>
              </optgroup>
            </select>
            <div class="select-arrow" v-if="showCountrySel"></div>
            <div v-else class="d-flex justify-content-center">
              <div class="spinner-border mt-1" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-8">
          <input
              type="tel"
              v-model="fakeTel"
              key="fakeTel"
              class="form-control"
              :placeholder="placeholder"
              @keyup="cleanFakeTelFormat"
              :class="[{'border-danger' : $v.content.$error}]"
          />
          <template v-if="$v.content.$error || $v.fakeContent.$error">
            <span class="error-info-text" v-if="$v.content.telValidate === false">Bitte mit Vorwahl angeben</span>
          </template>
        </div>
      </div>
      <!--      {{ $v.fakeContent }}-->

      <template v-if="$v.content.$error || $v.fakeContent.$error">
        <!--<small class="" v-if="$v.content.required === false || $v.fakeContent.required === false">Pflichtangabe</small>-->
        <span class="error-info-text" v-if="$v.content.ibanValidate === false">Bitte geben Sie eine gültige IBAN an.</span>
        <span class="error-info-text" v-else-if="$v.content.bicValidate === false">Bitte geben Sie eine gültige BIC an.</span>
        <span class="error-info-text" v-else-if="$v.content.email === false">Bitte geben Sie eine gültige E-Mail-Adresse an.</span>
        <span class="error-info-text" v-else-if="$v.fakeContent.decimal === false">Bitte geben Sie eine Zahl ein.</span>
        <span class="error-info-text" v-else-if="$v.content.integer === false">Bitte geben Sie eine ganze Zahl ein.</span>
        <span class="error-info-text" v-else-if="$v.fakeContent.minValue === false">Bitte geben Sie einen Wert größer gleich {{ $v.fakeContent.$params.minValue.min }} an.</span>
        <span class="error-info-text" v-else-if="$v.content.minValue === false">Bitte geben Sie einen Wert größer gleich {{ $v.content.$params.minValue.min }} an.</span>
        <span class="error-info-text" v-else-if="$v.fakeContent.maxValue === false">Bitte geben Sie einen Wert kleiner gleich {{ $v.fakeContent.$params.maxValue.max }} an.</span>
        <span class="error-info-text" v-else-if="$v.content.maxValue === false">Bitte geben Sie einen Wert kleiner gleich {{ $v.content.$params.maxValue.max }} an.</span>
        <span class="error-info-text" v-else-if="$v.content.dateStringValidate === false">Bitte geben Sie ein Datum ein.</span>
        <!--<span class="error-info-text" v-else-if="$v.content.telValidate === false">Bitte geben Sie eine Telefonummer an - ggf. mit Ihrer regionalen Vorwahl.</span>-->
      </template>
    </div>
  </div>

  <div v-else :class="col">
    <label class="bold-600" v-if="label">
      {{ label }}
      <template v-if="$v.content.$error || $v.fakeContent.$error">
        <span style="color: #dc3545 !important" v-if="$v.content.required === false || $v.fakeContent.required === false">*</span>
      </template>
    </label>
    <div class="rueden-input">
      <textarea :placeholder="placeholder" :required="required" class="form-control" v-model="content"></textarea>
    </div>
  </div>

</template>
<script>
import General from '@/mixins/general';
import Datepicker from 'vuejs-datepicker';
import {de} from 'vuejs-datepicker/dist/locale';
import { required, email, integer, decimal, minValue, maxValue } from 'vuelidate/lib/validators'
import axios from "axios";

const EMAIL_PATTERN = "(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|\"(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21\\x23-\\x5b\\x5d-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])*\")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\\x01-\\x08\\x0b\\x0c\\x0e-\\x1f\\x21-\\x5a\\x53-\\x7f]|\\\\[\\x01-\\x09\\x0b\\x0c\\x0e-\\x7f])+)\\])";
const PHONE_PATTERN = "(\\+)?([\\/() 0-9]){6,}";
const IBAN_PATTERN = "[A-Z]{2}\\d{2} (?:\\d{4} ){3}\\d{4}(?: \\d\\d?)?";
const BIC_PATTERN = "[A-Z]{6,6}[A-Z2-9][A-NP-Z0-9]([A-Z0-9]{3,3}){0,1}";
const DATE_OPTIONS = { year: 'numeric', month: '2-digit', day: '2-digit' };
const FAVORIT_COUNTRIES = ["DE","CH","AT"];
const PRESELECT_COUNTRY = 'DE';
const PNF = require('google-libphonenumber').PhoneNumberFormat;

const phoneUtil = require('google-libphonenumber').PhoneNumberUtil.getInstance();
const ibantools = require('ibantools');
const IOS_V = (window.navigator.appVersion).match(/OS (\d+)_(\d+)_?(\d+)?/);

const ibanValidate = (value) => ibantools.isValidIBAN(ibantools.electronicFormatIBAN(value));
const bicValidate = (value) => ibantools.isValidBIC(value);
const dateStringValidate = function (value) {
  if (value) {
    let parts = value.split(".");
    if (parts.length > 1) return !isNaN(new Date(parts[2] + "-" + parts[1] + "-" + parts[0]));
    return !isNaN(new Date(value));
  }
  return false;
}
const telValidate = function (value) {
  try {
    const phone = phoneUtil.parseAndKeepRawInput(value);
    return (phoneUtil.isValidNumber(phone) && phoneUtil.isPossibleNumber(phone));
  } catch (e) {
    return false;
  }
}

export default {
  mixins: [General],
  components: {Datepicker},
  props: {
    value: String,
    type: {
      type: String,
      default: 'text'
    },
    label: String,
    placeholder: {
      type: String,
      default: '',
    },
    col: {
      type: String,
      default: 'col-12 col-md-6'
    },
    gaCat: String,
    required: {
      type: Boolean,
      default: false
    },
    tooltip: String
  },
  data: function () {
    return {
      content: this.value,
      fakeContent: null,
      pattern: null,
      htmlType: this.type,
      htmlMin: '',
      htmlMax: '',
      htmlStep: '',
      hasFocus: false,
      lang: de,
      showFakeControl: (
          this.type == 'currency'
          || (this.type == 'date' && this.isDateInputSupported())
      ),
      showDatePicker: false,
      preSelectCountry: null,
      favCountries: FAVORIT_COUNTRIES,
      countrySelect: PRESELECT_COUNTRY,
      fakeTel: '0',
      showCountrySel: typeof this.$global.countries !== 'undefined',
      os: window.navigator.platform.toLowerCase(),
      iOSv: IOS_V ? parseInt(IOS_V[1]) : false,
    }
  },
  validations() {
    let rules = { content: {}, fakeContent: {}};
    if (this.required) {
      if (!this.showFakeControl) {
        rules.content = {...rules.content, ...{ required }};
      } else {
        rules.fakeContent = {...rules.fakeContent, ...{ required }};
      }
    }
    if (this.type == 'iban') {
      rules.content = {...rules.content, ...{ ibanValidate }};
    } else if (this.type == 'bic') {
      rules.content = {...rules.content, ...{ bicValidate }};
    } else if (this.type == 'email') {
      rules.content = {...rules.content, ...{ email }};
    } else if (this.type == 'currency') {
      rules.fakeContent = {...rules.fakeContent, ...{ decimal, minValue: minValue(0.01) }};
    } else if (this.type == 'date') {
      rules.content = {...rules.content, ...{ dateStringValidate }};
      rules.fakeContent = {...rules.fakeContent, ...{ dateStringValidate }};
    } else if (this.type == 'zip') {
      rules.content = {...rules.content, ...{ integer, minValue: minValue(1000), maxValue: maxValue(99999) }};
    } else if (this.type == 'tel') {
      if (!this.iOSv || this.iOSv >= 13) rules.content = {...rules.content, ...{ telValidate }};
    }
    return rules;
  },
  beforeCreate() {
    let _this = this;
    if (!_this.$global.countries) {
      _this.$global.countries = [];
      axios.get('https://countriesnow.space/api/v0.1/countries/codes')
          .then(response => {
            response.data.data.forEach(function (c) {
              c.flag = false;
              if (_this.os.substring(0,3) !== 'win' && (!_this.iOSv || _this.iOSv >= 13)) {
                axios.post('https://countriesnow.space/api/v0.1/countries/flag/unicode', {"country": c.name})
                    .then(response => {
                      _this.showCountrySel = false;
                      if (response.data.data) {
                        c.flag = response.data.data.unicodeFlag;
                      }
                      _this.$global.countries.push(c);
                      _this.$global.countries.sort((a, b) => (a.code > b.code) ? 1 : ((b.code > a.code) ? -1 : 0))
                      _this.showCountrySel = true;
                    });
              } else {
                _this.$global.countries.push(c);
                _this.$global.countries.sort((a,b) => (a.code > b.code) ? 1 : ((b.code > a.code) ? -1 : 0));
                _this.showCountrySel = true;
              }
            });
          });
    }
  },
  mounted() {
    if (!this.showFakeControl && this.$v.content.$invalid) {
      this.changeErrorCount(true);
      // console.log("+1",(this.label ? this.label : this.placeholder) + " erstellt");
    }
    if (this.showFakeControl && this.$v.fakeContent.$invalid) {
      this.changeErrorCount(true);
      // console.log("+1",(this.label ? this.label : this.placeholder) + " erstellt");
    }
    if (this.type == 'email') {
      this.pattern = EMAIL_PATTERN;
    } else if (this.type == 'tel') {
      this.pattern = PHONE_PATTERN;
      if (this.value) {
        let dial_code = this.value.split(" ")[0];
        if (!this.iOSv || this.iOSv > 13) {
          try {
            const number = phoneUtil.parseAndKeepRawInput(this.value, PNF.INTERNATIONAL);
            this.fakeTel = phoneUtil.format(number, this.value).replace(/^0*/, '0');
          } catch {
            this.fakeTel = this.value.replace(dial_code, '').trim().replace(/^0*/, '0');
          }
          this.countrySelect = this.$global.countries.find(c => c.dial_code == dial_code).code;
        }
      }
    } else if (this.type == 'iban') {
      this.pattern = IBAN_PATTERN;
      this.htmlType = "text";
    } else if (this.type == 'bic') {
      this.pattern = BIC_PATTERN;
      this.htmlType = "text";
    } else if (this.type == 'currency') {
      this.htmlType = 'number';
      this.htmlMin = '0.01';
      this.htmlStep = '0.01';
      if (this.value) this.fakeContent = parseFloat(this.value.replaceAll('.','').replace(',','.').replace(' €',''))
    } else if (this.type == 'zip') {
      this.htmlType = 'number';
      this.htmlMin = '1111';
      this.htmlMax = '99999';
      this.htmlStep = '1';
    } else if (this.type == 'date') {
      if (this.showFakeControl) {
        if (this.value) {
          let parts = this.value.split(".");
          this.fakeContent = parts[2]+"-"+parts[1]+"-"+parts[0];
        }
      } else {
        this.showDatePicker = true;
      }
    }
  },
  methods: {
    updateValue(date=null) {
      if (this.type == 'date') {
        if (this.showDatePicker) {
          this.content = date.toLocaleDateString('de-DE', DATE_OPTIONS);
        } else if (date.target.valueAsDate) {
          this.content = date.target.valueAsDate.toLocaleDateString('de-DE', DATE_OPTIONS);
        }
      }
      this.content = this.strFormat(this.content);
      this.$emit('input', this.content);
      this.sendGaEvent(this.label ? this.label : this.placeholder);
    },
    changeFocus(val) {
      this.hasFocus = val;
      if (this.showDatePicker) {
        if (val) {
          this.$refs.mainInput.showCalendar();
        } else {
          setTimeout(() => {
            this.$refs.mainInput.closeCalendar();
          });
        }
      }
      if (val && this.showFakeControl) {
        setTimeout(() => {
          this.$refs.mainInput.focus();
        });
      }
    },
    isDateInputSupported() {
      var input = document.createElement('input');
      var value = 'a';
      input.setAttribute('type', 'date');
      input.setAttribute('value', value);
      return (input.value !== value);
    },
    cleanFormat(e) {
      if (['tel','bic','iban'].includes(this.type)) {
        let prevPos = e.target.selectionStart;
        if (this.content) {
          let newPos = this.strFormat(this.content.substring(0, prevPos)).length;
          this.content = this.strFormat(this.content);
          if (newPos != this.content.length) setTimeout(() => e.target.setSelectionRange(newPos, newPos));
        }
      }
    },
    cleanFakeTelFormat() {
      let tmp = this.fakeTel.replaceAll(/[a-zöüä]/gi,'').replace(/^0*/,'0');
      try {
        const number = phoneUtil.parseAndKeepRawInput(tmp, this.countrySelect);
        this.fakeTel = phoneUtil.format(number, this.countrySelect).replace(/^0*/,'0');
      } catch (e) {
        this.fakeTel = tmp;
      }
      this.content = this.strFormat(this.$global.countries.find(c => c.code === this.countrySelect).dial_code+tmp.replace(/^0*/,''));
      this.$emit('input', this.content);
      this.$v.content.$touch();
    },
    strFormat(str) {
      if (this.type == 'tel') {
        let tmp = str.replaceAll(/[a-zöüä]/gi,'');
        try {
          const number = phoneUtil.parseAndKeepRawInput(tmp,this.countrySelect);
          return phoneUtil.format(number, PNF.INTERNATIONAL)
        } catch (e) {
          return tmp;
        }
      }
      if (this.type == 'email') return str.toLowerCase().replaceAll(/[\s]/gi,'');
      if (this.type == 'bic') return str.replaceAll(/[^a-z\d\s:]/gi,'').toUpperCase();
      if (this.type == 'iban') return ibantools.friendlyFormatIBAN(str.replaceAll(/[^a-z\d\s:]/gi, '').toUpperCase());
      return str;
    },
  },
  watch: {
    fakeContent: function(c) {
      this.$v.fakeContent.$touch();
      if (this.type == 'currency') {
        this.content = String(new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(c));
      }
      if (this.type == 'date') {
        let date = new Date(c);
        if (!isNaN(date)) {
          this.content = date.toLocaleDateString('de-DE', DATE_OPTIONS);
        } else {
          this.content = "";
        }
      }
    },
    content: function() {
      if (this.type != 'tel') this.$v.content.$touch();
    },
    '$v.content.$invalid': function (newV) {
      if (!this.showFakeControl) {
        this.changeErrorCount(newV);
        // console.log(newV ? "+1" : "-1",(this.label ? this.label : this.placeholder) + " geändert");
      }
    },
    '$v.fakeContent.$invalid': function (newV) {
      if (this.showFakeControl) {
        this.changeErrorCount(newV);
        // console.log(newV ? "+1" : "-1",(this.label ? this.label : this.placeholder) + " geändert");
      }
    },
    $global: function (newV) {
      if (newV.showAllInputError) {
        if (this.showFakeControl) {
          this.$v.fakeContent.$touch();
        } else {
          this.$v.content.$touch();
        }
      }
    },
    countrySelect: function (newV) {
      // if (this.content) this.content = this.content.replaceAll(/[\s]/gi,'').replace(this.allCountries[oldV].dial_code,'').replace('+','');
      // this.content = this.strFormat(this.allCountries[newV].dial_code+this.content);
      let tmp = this.fakeTel.replaceAll(/[a-zöüä]/gi,'').replace(/^0*/,'0');
      try {
        const number = phoneUtil.parseAndKeepRawInput(tmp, newV);
        this.fakeTel = phoneUtil.format(number, newV).replace(/^0*/,'0');
        this.content = phoneUtil.format(number, PNF.INTERNATIONAL);
      } catch {
        this.fakeTel = tmp;
        this.content = this.$global.countries.find(c => c.code === this.countrySelect).dial_code+tmp.replace(/^0*/,'');
      }
      this.$emit('input', this.content);
    }
  },
  destroyed() {
    if (!this.showFakeControl && this.$v.content.$invalid) {
      this.changeErrorCount(false);
      // console.log("-1",(this.label ? this.label : this.placeholder) + " destroyed");
    } else if (this.showFakeControl && this.$v.fakeContent.$invalid) {
      this.changeErrorCount(false);
      // console.log("-1",(this.label ? this.label : this.placeholder) + " destroyed");
    }
  }
}
</script>
